import React from 'react';
import {Request} from "../helpers/request";
import SelectInput from "./form/asyncSelect";


export default function Countries(props) {

  const loadOptions = (inputValue, callback) => {
    Request({ method: 'GET', url: `/brandwatch/locations?prefix=${inputValue}`}).then(response => {
      callback(response.results.filter(location => !["continent", "region", "city"].includes(location.type)).map(country => {
        return { label: country.fullName, value: country.id, type: country.type }
      }))
    })
  };

  return (
    <>
      <div className="mb-20">
        <SelectInput
          className="react-select"
          isMulti
          name="location"
          placeholder="Location"
          required
          loadOptions={loadOptions}
          noOptionsMessage={() => 'please type country'}
          cacheOptions
          {...props}
        />
      </div>

      {props.error && <p className="mb2 text-violet-red">{props.error}</p>}
    </>
)
}